// 書籍、評論、特輯連載頁面
import axios from 'axios'
import {API_URL} from './config.js'
import { resolve } from 'url';

export default {
  getBookGroup: function (bookId , isSerial) {
    return new Promise((resolve, reject) => {
      let params = {
        bookGroupID: bookId,
        isSerial:typeof(isSerial)==undefined? true : isSerial
      }
      axios.get(`${API_URL}/Book${this.getParams(params)}`, this.getBearerToken()).then(response => {
        if(response.data.CoverURL === null){
          let params2 = {
            bookGroupID: bookId,
            isSerial:false
          }
          axios.get(`${API_URL}/Book${this.getParams(params2)}`, this.getBearerToken()).then(response => {
            this.book = response.data
            var _str = ""
            var result = ""
            if(response.data.Introduction != null){
              _str = response.data.Introduction.split('\r\n');
              for(var i=0;i<_str.length;i++){
                result += _str[i] + "<br />"
              }
              this.book.Introduction = result;
            }
            this.book.viewer = `/reader/FireBase3.html?bookID=${bookId}&isLogin=${this.isLogin}`
            resolve(response)
          }).catch(e => {
            reject(e)
          })
        }else{
          this.book = response.data
          var _str = ""
          var result = ""
          if(response.data.Introduction != null){
            _str = response.data.Introduction.split('\r\n');
            for(var i=0;i<_str.length;i++){
              result += _str[i] + "<br />"
            }
            this.book.Introduction = result;
          }
          this.book.viewer = `/reader/FireBase3.html?bookID=${bookId}&isLogin=${this.isLogin}`
          // this.getEpisodeOfSerials()
          resolve(response)
        }
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        // if(this.adBlockIsOpen){alert("請關閉adblock廣告阻擋套件以提升網站閱讀體驗")}else{alert(e.message)}
        reject(e)
      })
    })
  },
  getBook: function (bookId) {
    return new Promise((resolve, reject) => {
      let params = {
        bookID: bookId
      }
      axios.get(`${API_URL}/Book${this.getParams(params)}`, this.getBearerToken()).then(response => {
        this.book = response.data
        var _str = "";
        var result = ""
        if(response.data.Introduction != null){
          _str = response.data.Introduction.split('\r\n');
          for(var i=0;i<_str.length;i++){
            result += _str[i] + "<br />"
          }
          this.book.Introduction = result;
        }
        this.book.viewer = `/reader/FireBase3.html?bookID=${bookId}&isLogin=${this.isLogin}`
        // 0918火力新增ordering ??
        this.book.ordering = false
        resolve(response)
      })
    })
  },
  getEpisodeOfBook: function (bookGroupID, bookID) {
    return new Promise((resolve,reject) =>{
      let path = {
        bookGroupID: bookGroupID
      }
      let params = {
        bookID: bookID
      }
      axios.get(`${API_URL}/Book/BookVol/${this.getParams(path, false)}${this.getParams(params)}`, this.getBearerToken()).then(response => {
        //0918火力修改
        console.log('getEpisodeOfBook')
        this.getEpisodeOfBook = response.data
        if (!this.book.IsSerial) {
          this.bookVols = this.getEpisodeOfBook
          this.bookVols.newestBookID = this.bookVols[(this.bookVols.length)-1].BookID
        }
        this.getEpisodeOfBook.map(res => {
          res.viewer = `/reader/FireBase3.html?bookID=${res.BookID}&isLogin=${this.isLogin}`
          res.BookID == bookID? res.isSelected = true :res.isSelected = false
          res.isSerial = false
        })
        this.selectedBookVols = this.bookVols.filter(vol => vol.SelectedBook)
        resolve(response)
      }).catch(e => {
        console.log(e)
        // this.errors.push(e)
        // if(this.adBlockIsOpen){alert("請關閉adblock廣告阻擋套件以提升網站閱讀體驗")}else{alert(e.message)}
      })
    })
  },
  getEpisodeOfSerials: function (bookGroupID, bookID) {
    var isGroup = this.getUrlParams('isGroup')
    return new Promise((resolve,reject) =>{
      let path = {
        bookGroupID: bookGroupID
      }
      let params = {
        bookID: bookID,
        isSerial: true
      }
      axios.get(`${API_URL}/Book/BookVol/${this.getParams(path, false)}${this.getParams(params)}`, this.getBearerToken()).then(response => {
        //0918火力修改
        console.log('getEpisodeOfSerials')
        this.getEpisodeOfSerials = response.data
        // if (this.book.IsSerial) this.bookVols = this.getEpisodeOfSerials
        this.bookVols = this.getEpisodeOfSerials
        this.bookVols.newestBookID = this.bookVols[(this.bookVols.length)-1].BookID
        this.getEpisodeOfSerials.map(res => {
          if(isGroup==="true"){
            this.book.viewer = `/reader/FireBase3.html?bookID=${this.bookVols.newestBookID}&isLogin=${this.isLogin}`
          }
          res.viewer = `/reader/FireBase3.html?bookID=${res.BookID}&isLogin=${this.isLogin}`
          res.BookID == bookID? res.isSelected = true :res.isSelected = false
          res.isSerial = true
        })
        resolve(response)
      }).catch(e => {
        console.log(e)
        // this.errors.push(e)
        // if(this.adBlockIsOpen){alert("請關閉adblock廣告阻擋套件以提升網站閱讀體驗")}else{alert(e.message)}
      })
    })
  },
  getNewestBookID: function(book){
    return new Promise((resolve,reject) =>{
      axios.get(`${API_URL}/Book/BookVol/${book.BookGroupID}?isSerial=${book.IsSerial}`).then(response =>{
        if(response.data.length>0){
          for(var i=0 ; i<response.data.length; i++){
            if(!response.data[response.data.length-(1+i)].IsUpcoming){
              this.newestID = response.data[response.data.length-(1+i)].BookID
              i = response.data.length
              resolve(this.newestID)
            }
          }
        }
      })
    })
  },
  getCommentList: function (bookGroupID, bookId, sortType, page=1) {
    return new Promise((resolve, reject) => {
      let path = {
        bookGroupID: bookGroupID
      }
      /* 因評論都是顯示所有集數 故bookID關 */
      let params = {
        // bookId: bookId,
        sortType: sortType,
        page: page
      }
      axios.get(`${API_URL}/Comment/List/${this.getParams(path, false)}${this.getParams(params)}`, this.getBearerToken()).then(response => {
        this.comments = response.data
        resolve(response.data)
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
      })
    })
  },
  getComment: function (CommentID) {
    let params = {
      CommentID: CommentID
    }
    axios.get(`${API_URL}/Comment/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // if(this.adBlockIsOpen){alert("請關閉adblock廣告阻擋套件以提升網站閱讀體驗")}else{alert(e.message)}
    })
  },
  editComment: function (bookID = '24f5a163-43a3-4f29-477e-08d5cad01720', comment, rank) {
    let params = {
      bookID: bookID,
      comment: comment,
      rank: rank
    }
    axios.post(`${API_URL}/Comment/Edit/${this.getParams(params, false)}`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  likeComment: function (CommentID = '24f5a163-43a3-4f29-477e-08d5cad01720') {
    let params = {
      CommentID: CommentID
    }
    axios.post(`${API_URL}/Comment/Like`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // if(this.adBlockIsOpen){alert("請關閉adblock廣告阻擋套件以提升網站閱讀體驗")}else{alert(e.message)}
    })
  },
  unLikeComment: function (CommentID = '24f5a163-43a3-4f29-477e-08d5cad01720') {
    let params = {
      CommentID: CommentID
    }
    axios.post(`${API_URL}/Comment/UnLike`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  getRecommendBookGroup: function (bookGroupID = '24f5a163-43a3-4f29-477e-08d5cad01720') {
    let params = {
      bookGroupID: bookGroupID
    }
    axios.get(`${API_URL}/Book/Related/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
      this.sellShelfs = [{
        'BookSetID': undefined,
        'Name': '推薦書籍',
        'Books': response.data
      }]
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // if(this.adBlockIsOpen){alert("請關閉adblock廣告阻擋套件以提升網站閱讀體驗")}else{alert(e.message)}
    })
  },
  getSpecialEditItem: function (spid = '0d8636736d5de8118123fcaa1472429a') {
    return new Promise((resolve, reject) => {
      let params = {
        spid: spid
      }
      axios.get(`${API_URL}/SpecialEdit/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
        // JSON responses are automatically parsed.
        this.specialItem = response.data
        var _str = "";
        var result = ""
        if(response.data.Body != null){
          _str = response.data.Body.split('\r\n');
          for(var i=0;i<_str.length;i++){
            result += _str[i] + "<br />"
          }
          this.specialItem.Body = result;
        }
        resolve(response)
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        reject(e)
        if (e) {
          alert(`SpecialEdit can not get the data from api`)
        }
      })
    })
  },
  getSpecialEditBookSetItem: function (bsid = '0d8636736d5de8118123fcaa1472429a') {
    let params = {
      bsid: bsid
    }
    axios.get(`${API_URL}/SpecialEdit/BookSet/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      console.log('getSpecialEditBookSetItem')
      if (response) {
        this.specialSectionItems.push(response.data)
      } else {
        alert('API return error')
      }
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  orderingVols: function (bookVols) {
    // bookVols = bookVols.reverse()
    //0918火力修改
    let item = $("#radio1")
    let order_arrow = $("#order_arrow")
    if(item.hasClass("radio1_active")){
      item[0].innerHTML = "升序"
      order_arrow[0].innerHTML = "↑"
    }else{
      item[0].innerHTML = "降序"
      order_arrow[0].innerHTML = "↓"
    }
    bookVols = bookVols.reverse()
    this.book.ordering = !this.book.ordering
  },
  toggleVolStatusSerial(vol,item){
    //修改書簡介&封面
    this.getBook(vol.BookID).then(function(res){
      document.getElementById("bookIntroduction").innerHTML = res.data.Introduction
    })

    for(var i=0 ;i<this.bookVols.length;i++){
      this.bookVols[i].isSelected = false
    }
    if (vol.isSelected) {
      vol.isSelected = false
      vol.SelectedBook = false
      this.selectedBookVols = this.bookVols.filter(vol => vol.SelectedBook)
    }else {
      vol.isSelected = true
      vol.SelectedBook = true
      this.selectedBookVols = this.bookVols.filter(vol => vol.SelectedBook)
    }
  // 0927改寫 Fa

  },
  toggleVolStatus (vol) {
    this.getBook(vol.BookID).then(function(res){
      //更改書籍頁敘述
      document.getElementById("bookIntroduction").innerHTML = res.data.Introduction
    })
    for(var i=0 ;i<this.bookVols.length;i++){
      this.bookVols[i].isSelected = false
      this.bookVols[i].SelectedBook = false
    }
    //0918火力修改
    if (vol.isSelected) {
      vol.isSelected = false
      vol.SelectedBook = false
      this.selectedBookVols = this.bookVols.filter(vol => vol.SelectedBook)
    }else {
      vol.isSelected = true
      vol.SelectedBook = true
      this.selectedBookVols = this.bookVols.filter(vol => vol.SelectedBook)
    }
    /*
    若已購買直接打開閱讀器
    else if (vol.IsPurchased&&!this.book.IsSerial) {
      window.open(vol.viewer)
    }
    */
  },
  //Fa for套書資訊
  gotoReader(bookID){
    window.open(`/reader/FireBase3.html?bookID=${bookID}&isLogin=${this.isLogin}`)
  },
  getTags: function (bookGroupID = '24f5a163-43a3-4f29-477e-08d5cad01720') {
    let params = {
      bookGroupID: bookGroupID
    }
    axios.get(`${API_URL}/Tag/List/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      this.bookTags = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  //火力新增function  0921修改 FA
  toggleBookVols: function () {
    var bookID = this.getUrlParams('id')
    var isGroup = this.getUrlParams('isGroup')
    this.showSerialsBook = !this.showSerialsBook
    if(isGroup=="true"){
      this.getBookGroup(bookID,!this.book.IsSerial).then(function(res){
        document.getElementById("bookIntroduction").innerHTML = res.data.Introduction
      })
    }else{
      this.getBookGroup(this.book.BookGroupID,!this.book.IsSerial).then(function(res){
        document.getElementById("bookIntroduction").innerHTML = res.data.Introduction
      })
    }
    var path = {
      bookGroupID: this.book.BookGroupID
    }
    if(this.showSerialsBook){
      let params = {
        isSerial: true
      }
      axios.get(`${API_URL}/Book/BookVol/${this.getParams(path, false)}${this.getParams(params)}`, this.getBearerToken()).then(response => {
        this.getEpisodeOfSerials = response.data
        this.bookVols = this.getEpisodeOfSerials
        this.getEpisodeOfSerials.map(res => {
          res.viewer = `/reader/FireBase3.html?bookID=${res.BookID}&isLogin=${this.isLogin}`
          res.isSelected = false
        })
      }).catch(e => {
        console.log(e)
      })
    }else{
      axios.get(`${API_URL}/Book/BookVol/${this.getParams(path, false)}`, this.getBearerToken()).then(response => {
        this.getEpisodeOfBook = response.data
        this.bookVols = this.getEpisodeOfBook
        this.getEpisodeOfBook.map(res => {
          res.viewer = `/reader/FireBase3.html?bookID=${res.BookID}&isLogin=${this.isLogin}`
          res.isSelected = false
        })
      }).catch(e => {
        console.log(e)
        // this.errors.push(e)
        // if(this.adBlockIsOpen){alert("請關閉adblock廣告阻擋套件以提升網站閱讀體驗")}else{alert(e.message)}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/book.js